import { AlgorithmStatusType } from '~/enums/AlgorithmStatusType';
import { UploadStatusType } from '~/enums/UploadStatusType';
import { Document } from '~/features/document-viewer/types/document';
import { intlService } from '~/i18n/IntlService';
import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

export interface AlgoStatus {
  title: string;
  status: AlgorithmStatusType;
  message: string;
  count: number;
}

interface Response {
  id: number;
  current_version: {
    file_name: string;
    file_type: string;
    id: PilotId;
  };
  document: number;
  date_added: string;
  user_added: number;
  algo_status: AlgoStatus[];
  date_modified: string;
  document_name: string;
  document_types: string[];
  file_type: string;
  is_processing_coordinates: boolean;
  parent_folder: number;
  party_list: string[];
  path: any[];
  payment_table: null;
  processing_status: UploadStatusType;
  provision_list: any[];
  provisions: any[];
  rebate_table: null;
  visibility_level: string;
}

export const getDocument = async (
  documentId: PilotId | undefined,
): Promise<Document> => {
  if (documentId === undefined) {
    throw new Error(
      intlService.getIntl().formatMessage({
        id: 'getDocument.documentIdRequired',
        defaultMessage: 'Document ID is required',
        description: 'Error message when document ID is undefined',
      }),
    );
  }
  const response: Response = await pilot.get(`document/${documentId}/`);

  return {
    id: response.id,
    name: response.document_name,
  };
};
